
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface JoinGymFormProps {
  code: string;
  isLoading: boolean;
  onChange: (value: string) => void;
  onSubmit: (e: React.FormEvent) => void;
  label?: string;
}

export const JoinGymForm = ({ 
  code, 
  isLoading, 
  onChange, 
  onSubmit, 
  label = "Código de gimnasio" 
}: JoinGymFormProps) => {
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.toUpperCase();
    onChange(value);
  };

  return (
    <form onSubmit={onSubmit} className="space-y-4">
      <div className="space-y-2">
        <Label htmlFor="gymCode">{label}</Label>
        <Input
          id="gymCode"
          placeholder="Ingresa el código de 6 caracteres"
          value={code}
          onChange={handleInputChange}
          maxLength={6}
          className="bg-background"
          disabled={isLoading}
        />
        <p className="text-sm text-muted-foreground">
          El código debe tener exactamente 6 caracteres
        </p>
      </div>
      <Button 
        type="submit" 
        disabled={isLoading || code.length !== 6}
        className="w-full"
      >
        {isLoading ? "Uniéndose..." : "Unirse al gimnasio"}
      </Button>
    </form>
  );
};
